import React from "react";
import HintPopover from "../hint-popover/hint-popover";

// import HintPopover from "src/core/gd-ui/hint-popover/hint-popover";

type Props = {
    renderType?     : 'default' | 'text' | 'property-30' | 'task-view' | 'task-view-toolbar'

    itemId          : ID | number
    itemName        : string

    // item url without goodday and id ie for task just "t/" or "contact/"
    itemUrl?        : string
    itemUrlId?      : string // should be specified if it does not match itemId

    // copy-id - single click copy ID
    // copy-url-and-id - single click copy url double click copy id

    copyId          : boolean
    copyUrl         : boolean

    className?      : string
}

export default class ItemId extends React.Component<Props> {

    debouncedSuccess    : any
    clickType    : any

    // static defaultProps = {
    //     renderType: 'default'
    // }

    constructor(props:Props) {
        super(props);

        this.clickType = null;
        this.debouncedSuccess = _.debounce(this.onSuccess.bind(this), 300);
    }

    componentWillUnmount() {
        this.debouncedSuccess.cancel();
    }

    fullUrl() {
        return 'https://www.goodday.work/{0}{1}'.f(this.props.itemUrl, this.props.itemUrlId ? this.props.itemUrlId : this.props.itemId);
    }

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();

        if (!this.props.copyId && !this.props.copyUrl) return;

        if (this.props.copyId && this.props.copyUrl) {
            this.clickType = !this.clickType ? 'single' : 'double';
            this.copyToClipboard();

        } else if (this.props.copyId) {

            gd.utils.copyToClipboard(this.props.itemId);
            gd.growl.success("{0} ID copied to clipboard".f(this.props.itemName));

        } else if (this.props.copyUrl) {

            gd.utils.copyToClipboard(this.fullUrl());
            gd.growl.success("{0} link copied to clipboard".f(this.props.itemName));

        }
    };

    copyToClipboard = () => {
        switch (this.clickType) {
            case 'single': gd.utils.copyToClipboard(this.fullUrl()); break;
            case 'double': gd.utils.copyToClipboard(this.props.itemId); break;
        }

        this.debouncedSuccess();
    };

    onSuccess = () => {
        switch (this.clickType) {
            case 'single': gd.growl.success("Link copied to clipboard"); break;
            case 'double': gd.growl.success("Item ID copied to clipboard"); break;
        }

        this.clickType = null;
    };

    getHintMessage = () => {
        let res :any = false;

        if (this.props.copyId && this.props.copyUrl) {
            res = "{0} ID \\n Click to copy {0} link.\\n Double click to copy {0} ID.".f(this.props.itemName)
        } else if (this.props.copyId) {
            res = "{0} ID \\n Click to copy.".f(this.props.itemName)
        } else if (this.props.copyUrl) {
            res = "{0} ID \\n Click to copy {0} link.".f(this.props.itemName)
        }

        return res;
    }

    render() {
        const hintMessage = this.getHintMessage();

        switch (this.props.renderType) {
            case 'text':
                return (
                    <div className={Classes("ui5-txt-default", this.props.className)} onClick={this.onClick}>
                        #{this.props.itemId}
                        {hintMessage && <HintPopover parent={this} multiline={true} hint={hintMessage} />}
                    </div>
                )

            case 'property-30':
                return (
                    <div className={Classes("ui5-property size-30 txt-truncate", "not-selectable", this.props.className)} onClick={this.onClick}>
                        # {this.props.itemId}
                        {hintMessage && <HintPopover parent={this} multiline={true} hint={hintMessage} />}
                    </div>
                )

            case 'task-view':
                const classes = Classes("ui5-property white-bg flex-type txt-truncate not-selectable border-box h-24 p-h-0", this.props.className)

                return (
                    <div className  = {classes}
                         onClick    = {this.onClick}
                    >
                        <div className="icon-block ui5-txt-not-important-small">#</div>

                        <div className="ui5-txt-not-important-small p-h-8">
                            {this.props.itemId}
                        </div>

                        {hintMessage &&
                            <HintPopover
                                multiline   = {true}
                                hint        = {hintMessage}
                            />}
                    </div>
                )

            // task view control panel - styled and hovers like the toolbar's control buttons
            case 'task-view-toolbar':
                return (
                    <div className  = {Classes("ui5-control-button s-28 p-h-6 flex-no-shrink", this.props.className)}
                         onClick    = {this.onClick}
                    >
                        <div className="i5-id fs-13 m-r-5"/>
                        <div className="label">{this.props.itemId}</div>

                        {hintMessage &&
                            <HintPopover
                                multiline   = {true}
                                hint        = {hintMessage}
                            />}
                    </div>
                )

            default:
                return (
                    <div className={Classes("ui5-property txt-truncate", "not-selectable", this.props.className)} onClick={this.onClick}>
                        #{this.props.itemId}
                        {hintMessage && <HintPopover parent={this} multiline={true} hint={hintMessage} />}
                    </div>
                )
        }
    }
}
